// extracted by mini-css-extract-plugin
export default {"companyInfoContainer":"CompanyInfoHeader_companyInfoContainer__aUBDV","companyInfoComponentContainer":"CompanyInfoHeader_companyInfoComponentContainer__cThG4"};